// External Dependencies:
import React from 'react'
import { NavLink } from 'react-router-dom'

class HomeImageLinks extends React.Component {
	render() {
		return (
			<div className="image-links-wrap">
				<div className="image-links">
					<div className="image-link-wrap">
						<NavLink to="/magazine" className="image-link -a" activeClassName="is-active">
							<div className="-inner">
								<div className="-title">
									<h3>Good News Magazine</h3>
								</div>

								<div className="-image">
									<img src={ `${siteData.images_url}cards/Good-News-Magazine.jpg` } alt="" />
								</div>
							</div>
						</NavLink>
					</div>

					<div className="image-link-wrap">
						<NavLink to="/events" className="image-link -b" activeClassName="is-active">
							<div className="-inner">
								<div className="-title">
									<h3>Events</h3>
								</div>

								<div className="-image">
									<img src={ `${siteData.images_url}cards/Events.jpg` } alt="" />
								</div>
							</div>
						</NavLink>
					</div>
				</div>

				<div className="image-links">
					<div className="image-link-wrap">
						<NavLink to="/colleges" className="image-link -c" activeClassName="is-active">
							<div className="-inner">
								<div className="-title">
									<h3>Colleges</h3>
								</div>

								<div className="-image">
									<img src={ `${siteData.images_url}cards/Colleges.jpg` } alt="" />
								</div>
							</div>
						</NavLink>
					</div>

					<div className="image-link-wrap">
						<NavLink to="/news" className="image-link -a" activeClassName="is-active">
							<div className="-inner">
								<div className="-title">
									<h3>Latest News</h3>
								</div>

								<div className="-image">
									<img src={ `${siteData.images_url}cards/Latest-News.jpg` } alt="" />
								</div>
							</div>
						</NavLink>
					</div>
				</div>

				<div className="image-links">
					<div className="image-link-wrap">
						<NavLink to="/resources" className="image-link -b" activeClassName="is-active">
							<div className="-inner">
								<div className="-title">
									<h3>Resources</h3>
								</div>

								<div className="-image">
									<img src={ `${siteData.images_url}cards/goal.jpg` } alt="" />
								</div>
							</div>
						</NavLink>
					</div>

					<div className="image-link-wrap">
						<NavLink to="/videos" className="image-link -c" activeClassName="is-active">
							<div className="-inner">
								<div className="-title">
									<h3>Featured Videos</h3>
								</div>

								<div className="-image">
									<img src={ `${siteData.images_url}cards/Featured-Videos.jpg` } alt="" />
								</div>
							</div>
						</NavLink>
					</div>
				</div>
			</div>
		)
	}
}

export default HomeImageLinks



// WEBPACK FOOTER //
// ./components/PageHeader/HomeImageLinks.jsx